<template>
  <div>
   
      <div class="modal animated fadeIn " tabindex="-1" id="modulesLoaderModal" role="dialog" aria-hidden="true" data-backdrop="static">
        <div class="modal-dialog modal-sm" style="top: 40%;">
          <div class="modal-content">           
            <div class="modal-body">
              <div class="modal-fluid">
                <div class="row">
                  <div class="col-md-12">                    
                      <center> <img src='static/assets/images/ajax-loader.gif'/> deleting, please wait..</center>                     
                    </div>
                  </div>               
              </div>
            </div>
            
          </div>
        </div>
      </div>


    <fieldset class="border p-3">
      <legend class="auto-wp">
        <small style="font-size:15px; font-weight: bold">manage modules</small>
      </legend>
      <div>
  
</div>
      <div>
        <div class="modulesLoader">
          <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
          <i class="fa fa-spinner fa-spin" style="font-size:24px;color:blue"></i> loading modules...
        </div>
        <vue-good-table
          :columns="columns"
          :rows="modules"
          :fixed-header="true"
          :pagination-options="{
            enabled: true,
            mode: 'records',
            perPage: 6,
            position: 'bottom',
            perPageDropdown: [3, 7, 9],
            dropdownAllowAll: false,
            setCurrentPage: 1,
            nextLabel: 'next',
            prevLabel: 'prev',
            rowsPerPageLabel: 'Rows per page',
            ofLabel: 'of',
            pageLabel: 'page', // for 'pages' mode
            allLabel: 'All',
        }"
        >
          <template slot="table-row" slot-scope="props">
            <span v-if="props.column.field == 'Action'">                   
                 <button class="btn btn-danger btn-sm"  @click="deleteModule(props.row.id)"><i class="fa fa-trash"></i> delete</button>
                </span>
           
          </template>
        </vue-good-table>
      </div>
    </fieldset>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";


export default {
  
  data() {
    return {
      columns: [
        {
          label: "module Name",
          field: "module_name",
          type: "text",
          filterOptions: {
            enabled: true, // enable filter for this column
             placeholder: 'Filter module',
          }
        },        
        {
          label: "Action",
          field: "Action",
          width: '89px',
          html: true
        }
      ]
    };
  },
  created() {
    this.loadModules();
  },
  computed: {
     ...mapGetters(["modules"])
  },
  methods: {
    ...mapActions([
      "loadModules",
      "deleteModule"
      ])
  },
 
};
</script>
<style scoped>

</style>


// WEBPACK FOOTER //
// src/modules/managemodules.vue